import { createFileRoute } from '@tanstack/react-router'
import { ListChecks } from 'lucide-react'
import { SetupScreen } from '@/screens/workspace/SCR-002-setup'

export const Route = createFileRoute('/_app/w/$ws/setup')({
  staticData: { screen: {"id":"SCR-002","title":"Set up ESM","group":"Workspace","perm":"workspace.admin","order":3,"description":"Choose defaults for scopes, retention, review and channels.", icon: ListChecks } },
  component: SetupScreen,
})
